<div class="cd-section" id="regulations" style="background-color: white; padding-top: 10px;">
    <div class="container-fluid">
        <!-- Header -->
        <div class="row ">
            <div class="header-container neg-lift ">
                <img width="100%" src="../../assets/img/RegScale-Header-Logo_Dual.png" alt="" />
                <div class="top-left col-md-4">
                    <h5 style="color:white; font-weight: Bold; ">RegScale has developed RegScale University, a
                        comprehensive set
                        of training videos to help get you up to speed on our software
                        platform quickly. </h5>
                </div>
            </div>
        </div>
        <!-- Centered Copy-->
        <div class="row " style=" margin-top:-5%;">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h3><b>We have training for every aspect of RegScale. Choose your role to see a
                            curated playlist of videos to get you up to speed.</b></h3>
                </div>

            </div>
        </div>
        
        <!-- Training Videos by Role -->
        <training-roles></training-roles>

        <!-- Center Copy-->
        <div class="row " style=" margin-top:-5%;">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h3><b>Or search our training for something specific.</b></h3>
                    <div class="input-group mt-4">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="strSearch" aria-label="search" name="search" aria-describedby="basic-addon1" (keyup.enter)="search()">
                    </div>
                </div>
            </div>
        </div>

        <!-- 3 Cards per Row -->
        <div class="row" style="margin-top: 5%; margin-bottom: 10%;">
            <!-- Loop Over Each Filtered Video to Display -->
            <div *ngFor="let v of displayVideos" class="col-md-4">

                <div class="card">
                    <iframe style="min-height: 400px;"
					[src]="sanitizer.bypassSecurityTrustResourceUrl(v.url)"
					frameborder="0" allowfullscreen
				></iframe>
                    <div class="container" style="min-height: 150px;">
                        <hr>
                        <h4><b>{{ v.title }}</b></h4>
                        <p>{{ v.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


